import * as React from 'react';
import {
    BodyLargeEmphasized,
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    Sheet,
    YStack,
} from 'smoothie';

interface NeedMoreAccountsForPaycheckRoutingSheetProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: () => void;
}

const NeedMoreAccountsForPaycheckRoutingSheet = ({
    isOpen,
    onClose,
    onSubmit,
}: NeedMoreAccountsForPaycheckRoutingSheetProps) => {
    return (
        <Sheet
            isOpen={isOpen}
            onClose={onClose}
            title="Paycheck split"
            showCloseButton
        >
            <YStack gap={20}>
                <YStack gap={8}>
                    <BodyLargeEmphasized>
                        You need at least two Fruitful Cash accounts to get
                        started
                    </BodyLargeEmphasized>
                    <BodyMediumRegular color="$gray900">
                        Paycheck split lets you create rules for dividing income
                        across Fruitful Cash Accounts.
                    </BodyMediumRegular>
                </YStack>
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text="Open a Fruitful Cash Account"
                    onPress={(e) => {
                        e.stopPropagation();
                        onSubmit();
                    }}
                />
            </YStack>
        </Sheet>
    );
};

export default NeedMoreAccountsForPaycheckRoutingSheet;
